export const plansData = [
  {
    name: "Basic",
    price: "99",
    features: [
      { name: "Browser caching", included: true },
      { name: "Minification", included: true },

      {
        name: "Google Page Speed Desktop Score: Desktop 70+ Mobile Score 50+",
        included: true,
      },
      { name: "Website Load Time to 6s-7s", included: true },
      { name: "Delivery time: 1-4 days", included: true },
      { name: "Resize photos ", included: true },
      { name: "Database optimization", included: false },
      { name: "Software version upgrade", included: false },
    ],
  },
  {
    name: "Standard",
    price: "129",
    features: [
      { name: "Browser caching", included: true },
      { name: "Minification", included: true },
      { name: "Database optimization", included: true },

      {
        name: "Google Page Speed Desktop Score:  Desktop 80+ Mobile Score 60+",
        included: true,
      },
      { name: "Website Load Time to 4s-5s", included: true },
      { name: "Delivery time: 1-4 days", included: true },
      { name: "Resize photos", included: true },
      { name: "Software version upgrade", included: false },
    ],
  },
  {
    name: "Premium",
    price: "149",
    features: [
      { name: "Browser caching", included: true },
      { name: "Minification", included: true },
      { name: "Database optimization", included: true },
      { name: "Software version upgrade", included: true },
      {
        name: "Google Page Speed Desktop Score:  Desktop 90+ Mobile Score 70+",
        included: true,
      },
      { name: "Website Load Time to 1s-3s", included: true },
      { name: "Delivery time: 1-4 days", included: true },
      { name: "Resize photos ", included: true },
    ],
  },
];
